import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Shield, Home, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!password) {
      toast.error("Ingresa la contraseña de administrador");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, { password }, { withCredentials: true });
      toast.success("¡Acceso concedido!");
      navigate('/admin');
    } catch (error) {
      toast.error(error.response?.data?.detail || "Contraseña incorrecta");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4"
         style={{ 
           background: 'linear-gradient(135deg, #09090B 0%, #18181B 50%, #27272A 100%)',
           position: 'relative'
         }}>
      <div className="absolute inset-0 opacity-5" 
           style={{ 
             backgroundImage: `url('https://images.unsplash.com/photo-1721623777765-1381ba32859c?crop=entropy&cs=srgb&fm=jpg&q=85')`,
             backgroundSize: 'cover',
             backgroundPosition: 'center'
           }} />
      
      <div className="relative z-10 w-full max-w-md">
        <div className="mb-6">
          <Button 
            data-testid="back-home-admin-login"
            onClick={() => navigate('/')} 
            variant="ghost" 
            className="text-zinc-400 hover:text-white"
          >
            <Home className="w-4 h-4 mr-2" />
            Volver al inicio
          </Button>
        </div>

        <Card className="bg-zinc-900/80 backdrop-blur-xl border-white/10 p-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-pink-600 rounded-full mx-auto mb-4 flex items-center justify-center">
              <Shield className="w-8 h-8 text-white" />
            </div>
            <h1 className="font-unbounded font-bold text-3xl text-white mb-2">Panel Admin</h1>
            <p className="text-zinc-400">Acceso protegido</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <Label htmlFor="admin-password" className="text-zinc-300 mb-2 block flex items-center gap-2">
                <Lock className="w-4 h-4" />
                Contraseña de Administrador
              </Label>
              <Input
                id="admin-password"
                data-testid="input-admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-zinc-800 border-zinc-700 text-white h-14 text-lg"
                placeholder="Ingresa la contraseña"
                autoFocus
              />
            </div>

            <Button 
              data-testid="btn-admin-login-submit"
              type="submit" 
              disabled={loading}
              className="w-full h-14 bg-gradient-to-r from-pink-600 to-pink-500 hover:from-pink-500 hover:to-pink-400 text-white font-unbounded font-semibold text-lg shadow-[0_0_30px_rgba(236,72,153,0.3)] transition-all hover:scale-105"
            >
              {loading ? "Verificando..." : "Acceder al Panel"}
            </Button>
          </form>

          <div className="mt-6 p-4 bg-zinc-800/50 rounded-lg border border-zinc-700">
            <p className="text-zinc-400 text-sm text-center">
              <span className="text-pink-400 font-semibold">Contraseña por defecto:</span> admin123
            </p>
            <p className="text-zinc-500 text-xs text-center mt-2">
              Configurable en variables de entorno
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default AdminLogin;